import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c(VListItem,[_c(VListItemContent,[_c(VListItemSubtitle,[_vm._v(_vm._s(_vm.$t(`labels.${_vm.label}`)))]),_c(VListItemTitle,[_vm._v(_vm._s(`${_vm.broker.display}, ${_vm.broker.firm ? _vm.broker.firm.display : ''}`))])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }